"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardHomeDetailsList = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledToken = _interopRequireDefault(require("styled-token"));
var StyledPropertyCardHomeDetailsList = /*#__PURE__*/_styledComponents.default.ul.withConfig({
  displayName: "StyledPropertyCardHomeDetailsList",
  componentId: "c11n-8-107-0__sc-1j0som5-0"
})(["display:inline;list-style:none;margin:0;padding:0;li{display:inline;}&:not(:last-child):after,li:not(:last-child):after{content:' | ';color:", ";}"], (0, _styledToken.default)('colors.gray400'));
exports.StyledPropertyCardHomeDetailsList = StyledPropertyCardHomeDetailsList;